import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { TransactionType } from "__generated__/enums";

const VatCodeTransactionTypeSelect = ({ ...rest }: Omit<SelectProps<TransactionType, false>, "fetchOptions" | "paginated" | "disableSearch">) => {
	return (
		<Select
			{...rest}
			fetchOptions={[ TransactionType.Purchase, TransactionType.Sales, TransactionType.Both ]}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			disableSearch />
	);
};

export default VatCodeTransactionTypeSelect;
